import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from 'common/react/utils/translations';
import { useDispatch, useSelector } from 'react-redux';
import { navSelector } from 'store/modules/competition-nav/selectors';
import {
    changeCompetition,
    changeSeason
} from 'store/modules/competition-nav/thunks';
import { setNavItem } from 'store/modules/competition-nav/init';

/**
 * @param {Array<string>} [filterKeys] - Keys to check for existing filters.
 * @returns {React.ReactElement} Component.
 */

export const ResetFilters = ({ filterKeys = [] }) => {
    const nav = useSelector(navSelector);
    const dispatch = useDispatch();
    const initialCompetitionId = nav?.competition?.initialItemId || '';
    const initialSeasonId = nav?.season?.initialItemId || '';
    const isDefaultCompetition = nav?.competition?.id === initialCompetitionId;
    const isDefaultSeason = nav?.season?.id === initialSeasonId;
    const isDefaultHomeAway = nav?.homeAway === 'all';

    const resetHandler = () => {
        if (!isDefaultCompetition) {
            dispatch(
                changeCompetition({
                    competition: {
                        id: initialCompetitionId
                    }
                })
            );
        }
        if (!isDefaultSeason) {
            dispatch(
                changeSeason({
                    season: {
                        id: initialSeasonId
                    }
                })
            );
        }
        if (!isDefaultHomeAway) {
            dispatch(
                setNavItem({
                    navItem: 'homeAway',
                    value: 'all'
                })
            );
        }
    };

    const hasAnyFilters = () => {
        const filters = nav?.filters || {};
        return (
            filterKeys.some(
                (key) => Array.isArray(filters[key]) && filters[key].length > 0
            ) ||
            !isDefaultCompetition ||
            !isDefaultSeason ||
            !isDefaultHomeAway
        );
    };

    return (
        <div className="stats-leaders-filters">
            <div className="stats-leaders-filters__item-wrapper stats-leaders-filters__item-wrapper--reset">
                {hasAnyFilters() ? (
                    <button
                        className="stats-leaders-filter-reset-button"
                        onClick={resetHandler}
                    >
                        {getTranslation(
                            'label.statsLeaders.filters.resetButtonText'
                        )}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

ResetFilters.propTypes = {
    filterKeys: PropTypes.arrayOf(PropTypes.string)
};
